import axios from 'axios';
import { push } from 'react-router-redux';

// Constants.
import * as PayHistoryConstants from 'constants/PayHistoryConstants';
import * as ErrorConstants from 'constants/ErrorConstants';
import {goToLogin} from "./AuthActions";

function requestLoadPayHistory() {
  return {
    type: PayHistoryConstants.LOAD_PAY_HISTORY_REQUEST,
  };
}

function receiveLoadPayHistory(payHistory) {
  return {
    type: PayHistoryConstants.LOAD_PAY_HISTORY_SUCCESS,
    payHistory,
  };
}

function receiveLoadPayHistoryError(response) {
  return {
    type: ErrorConstants.LOAD_REQUEST_FAILURE,
    response,
  };
}

export function loadPayHistory() {
  return (dispatch, getState) => {
    dispatch(requestLoadPayHistory());
    const { payHistory: { limit } } = getState();
    axios({
      method: 'GET',
      url: '/dashboard_api/v1/billing/transactions/',
      params: {
        limit,
        offset: 0,
      },
    })
      .then((response) => {
        const payHistory = response.data;
        dispatch(receiveLoadPayHistory(payHistory));
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            dispatch(goToLogin());
          }
          else {
            dispatch(receiveLoadPayHistoryError(error.response));
            // dispatch(push({ pathname: '/error' }));
          }
        }
      });
  };
}

function requestLoadPayHistoryMore() {
  return {
    type: PayHistoryConstants.LOAD_PAY_HISTORY_MORE_REQUEST,
  };
}

function receiveLoadPayHistoryMore(payHistory) {
  return {
    type: PayHistoryConstants.LOAD_PAY_HISTORY_MORE_SUCCESS,
    payHistory,
  };
}

function receiveLoadPayHistoryMoreError(response) {
  return {
    type: ErrorConstants.LOAD_REQUEST_FAILURE,
    response,
  };
}

export function loadPayHistoryMore() {
  return (dispatch, getState) => {
    dispatch(requestLoadPayHistoryMore());
    const { payHistory: { limit, offset } } = getState();
    axios({
      method: 'GET',
      url: '/dashboard_api/v1/billing/transactions/',
      params: {
        limit,
        offset,
      },
    })
      .then((response) => {
        const payHistory = response.data;
        dispatch(receiveLoadPayHistoryMore(payHistory));
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            dispatch(goToLogin());
          }
          else {
            dispatch(receiveLoadPayHistoryMoreError(error.response));
            // dispatch(push({ pathname: '/error' }));
          }
        }
      });
  };
}
